import React from "react";
import styles from '../ChatMessages/ChatMessages.module.sass'
import UserPhoto from "../../../components/UserPhoto";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import cn from 'classnames';
import { ChatContext } from "../../../contexts/ChatContext";
import { useContext } from "react";
import { UserContext } from "../../../contexts/UserContext";

const ChatMessage = ({ data, isOwnLastMessage }) => {

    data = data.data && typeof data.data != 'string' ? data.data : data;
    const chatContext = useContext( ChatContext );
    const ownerAvatar = chatContext.avatars[data.avatarID];

    return (
        <>
            <div className={styles.avatar}>
                { isOwnLastMessage && <UserPhoto data={ownerAvatar}/>}
            </div>
            <div className={styles.content}> <span>{data.text || data.data}</span> </div>
            <div className={styles.time}>{data.dateString}</div>
        </>
    );

};

export default ChatMessage;